"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createmarkdownStyles = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _borders = require("../../fuse-borders/src/borders");
var _colours = _interopRequireDefault(require("../../fuse-colours/src/colours"));
var _elevation = require("../../fuse-elevation/src/elevation");
var _gridConfig = require("../../fuse-responsive-grid/src/grid-config");
var _spacing = require("../../fuse-spacing/src/spacing");
var _typography = require("../../fuse-typography/src/typography");
var _themesConfig = require("./themes-config");
var _excluded = ["brand"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var validBrands = ['very', 'littlewoods', 'default'];
var propTypes = {
  brand: _propTypes["default"].oneOf(validBrands)
};
var defaultProps = {
  brand: 'very'
};

/* Font Family  */
var createBrandFontFamilyCss = function createBrandFontFamilyCss(brand) {
  return "--font-brand: ".concat(_themesConfig.themesConfig[brand].fontFamily, ";");
};
/* Base Font Size */
var baseFontSizeCss = "--font-base-size: 62.5%;";

/**
 * Generates the typography (display, heading and paragraph) CSS based on the typography object from @tvg/fuse-typography
 * @param {string} prefix
 * @param {object} typoObj
 * @returns {string} typography css
 */
var generateTypographyCustomProperties = function generateTypographyCustomProperties(brand) {
  var displayFontWeight = "--font-weight-display: ".concat((0, _typography.display)(brand).fontWeight, ";"); // displayFontWeight
  var headingFontWeight = "--font-weight-heading: ".concat((0, _typography.heading)(brand).fontWeight, ";"); // headingFontWeight
  var paragraphFontWeight = "--font-weight-paragraph: ".concat((0, _typography.paragraph)(brand).fontWeight, ";"); // paragraphFontWeight

  var displayFontColor = "--color-font-display: ".concat((0, _typography.display)(brand).fontColor, ";"); // displayFontColor
  var headingFontColor = "--color-font-heading: ".concat((0, _typography.heading)(brand).fontColor, ";"); // headingFontColor
  var paragraphFontColor = "--color-font-paragraph: ".concat((0, _typography.paragraph)(brand).fontColor, ";"); // paragraphFontColor

  var typographyCustomProps = [displayFontWeight, paragraphFontWeight, headingFontWeight, displayFontColor, paragraphFontColor, headingFontColor].join('');
  var typographySizeCustomProps = Object.keys(_typography.defaultCssProps).map(function (key) {
    return "--font-size-".concat(key.replace('t', ''), ": calc(").concat(_typography.defaultCssProps[key].fontSize, " * 1.6);\n\t\t\t\t--font-size-em-").concat(key.replace('t', ''), ": calc(").concat(_typography.defaultCssProps[key].fontSize.replace('rem', 'em'), " * 1.6);\n\t\t\t\t--font-line-height-").concat(key.replace('t', ''), ": calc(").concat(_typography.defaultCssProps[key].lineHeight, " * 1.6);\n\t\t\t\t--font-line-height-em-").concat(key.replace('t', ''), ": calc(").concat(_typography.defaultCssProps[key].lineHeight.replace('rem', 'em'), " * 1.6);\n\t\t\t\t--spacing-paragraph-margin-bottom-").concat(key.replace('t', ''), ": ").concat(_typography.defaultCssProps[key].marginBottom, ";\n\t\t\t\t--spacing-paragraph-margin-bottom-em-").concat(key.replace('t', ''), ": ").concat(_typography.defaultCssProps[key].marginBottom.replace('rem', 'em'), ";");
  }).join('').replace(' ', '');
  var sortedTypographyVariables = (typographyCustomProps + typographySizeCustomProps).split(';').sort().join(';');
  return "".concat(sortedTypographyVariables, ";");
};

/* Old Spacing Tokens - to be removed upon decommissioning */
var createOldSpacingCustomProperties = function createOldSpacingCustomProperties() {
  return Object.keys(_spacing.spacing).map(function (key) {
    return "--spacing-".concat(key, ": calc(").concat(_spacing.spacing[key], " * 1.6);");
  }).join('');
};

/* New Spacing Tokens discernable from the old takens with the -global prefix */
var createNewSpacingCustomProperties = function createNewSpacingCustomProperties() {
  return Object.keys(_spacing.globalSpacingTokens).map(function (key) {
    return "--spacing-global-".concat(key, ": calc(").concat(_spacing.globalSpacingTokens[key], " * 1.6);");
  }).join('');
};

/* Page Spacing Tokens */
var createPageSpacingCustomProperties = function createPageSpacingCustomProperties() {
  return Object.keys(_spacing.pageSpacingTokens).map(function (key) {
    return "--spacing-page-".concat(key, ": calc(").concat(_spacing.pageSpacingTokens[key], " * 1.6);");
  }).join('');
};

// Iterate through themesConfig brand color object and create a string consisting of css vars for colors
var createBrandColoursCustomProperties = function createBrandColoursCustomProperties(brand) {
  return Object.keys(_themesConfig.themesConfig[brand].color).reduce(function (acc, currentItem) {
    return "".concat(acc, "--color-brand-").concat(currentItem, ": ").concat(_themesConfig.themesConfig[brand].color[currentItem], ";");
  }, '');
};
var createColoursCustomProperties = function createColoursCustomProperties() {
  return Object.keys(_colours["default"]).map(function (group) {
    return Object.keys(_colours["default"][group]) // loop through first level
    .map(function (colour) {
      return "--color-".concat(group, "-").concat(colour, ": ").concat(_colours["default"][group][colour], "; ");
    }) // loop through values
    .join('');
  }).join('');
};
var createElevationCustomProperties = function createElevationCustomProperties() {
  return Object.keys(_elevation.elevation).map(function (group) {
    return Object.keys(_elevation.elevation[group]).reduce(function (acc, currentToken) {
      // Check if it's old token, if so amend the css variable string
      var oldToken = /[0-9]/g.test(currentToken);
      var cssVar = oldToken ? "--elevation-".concat(group, "-").concat(currentToken, ": ").concat(_elevation.elevation[group][currentToken], ";") : "--elevation-".concat(currentToken, ": ").concat(_elevation.elevation[group][currentToken], ";");
      // Return accumulator with all CSS variable strings
      return acc + cssVar;
    }, '');
  }).join('');
};
var createBorderCustomProperties = function createBorderCustomProperties() {
  return Object.keys(_borders.borders).map(function (properties) {
    return Object.keys(_borders.borders[properties]) // loop through border radius and border width
    .map(function (size) {
      return "--border-".concat(properties, "-").concat(size, ": ").concat(_borders.borders[properties][size], ";");
    }) // loop through the sizes
    .join('');
  }).join('');
};
var createmarkdownStyles = exports.createmarkdownStyles = function createmarkdownStyles(brand) {
  var defaultHeading = _themesConfig.themesConfig[brand].defaultHeading;

  /**
   * This generates CSS for h1 to h6 i.e. h1.markdown__h1, h2.markdown__h2, etc.
   * @param {string} size - This is directly related to typography config heading sizes from M3 (smallest) - 14 (largest)
   * @returns Specific CSS string that outputs styles related to heading size
   */
  var setHeadingCSS = function setHeadingCSS(size) {
    var color = "var(--color-font-heading)";
    var fontSize = "var(--font-size-".concat(size.toLowerCase(), ")");
    var fontWeight = "var(--font-weight-heading)";
    var lineHeight = "var(--font-line-height-".concat(size.toLowerCase(), ")");
    var marginBottom = "var(--spacing-paragraph-margin-bottom-".concat(size.toLowerCase(), ")");
    return "\n\t\t\tcolor: ".concat(color, ";\n\t\t\tfont-size: ").concat(fontSize, ";\n\t\t\tfont-weight: ").concat(fontWeight, ";\n\t\t\tline-height: ").concat(lineHeight, ";\n\t\t\tmargin-bottom: ").concat(marginBottom, ";");
  };
  var renderViewportHeadingCSS = function renderViewportHeadingCSS(viewports, headingTags) {
    return viewports.map(function (viewport) {
      return "@media screen and (min-width: ".concat(_gridConfig.gridConfig[viewport].minWidth, ") {\n\t\t\t\t\t").concat(headingTags.map(function (tag) {
        return "\n\t\t\t\t\t\t".concat(tag, ".markdown__").concat(tag, " {\n\t\t\t\t\t\t\t").concat(setHeadingCSS(defaultHeading[viewport][tag]), "\n\t\t\t\t\t\t}");
      }), "\n\t\t\t\t}");
    }).join('');
  };
  return "\n\t\t".concat(renderViewportHeadingCSS(Object.keys(defaultHeading), ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']), "\t\n\n\n\t\tp.markdown__typography-paragraph {\n\t\t\tcolor: var(--color-font-paragraph);\n\t\t\tfont-size: var(--font-size-1);\n\t\t\tfont-weight: var(--font-weight-paragraph);\n\t\t\tline-height: var(--font-line-height-1);\n\t\t\tmargin-bottom: var(--spacing-paragraph-margin-bottom-1);\n\t\t}\n\n\t\tem.markdown__color-brand-mid {\n\t\t\tcolor: var(--color-brand-mid);\n\t\t\tfont-style: normal;\n\t\t}\n\n\t\tstrong.markdown__typography-bold {\n\t\t\tfont-weight: var(--font-weight-heading); // 700 as bold\n\t\t}\n\n\t\ta.markdown__link {\n\t\t\t").concat(_fuseUtils.AnchorCss, "\n\t\t}\n\n\t\tol.markdown__ordered-list {\n\t\t\tlist-style-type: decimal; \n\t\t\tpadding: 0 0 0 var(--spacing-global-space6)\n\t\t}\n\n\t\tul.markdown__unordered-list {\n\t\t\tlist-style-type: disc; \n\t\t\tpadding: 0 0 0 var(--spacing-global-space6)\n\t\t}\n\n\t\tli.markdown__ordered-list-item,\n\t\tli.markdown__unordered-list-item { \n\t\t\tcolor: var(--Grey-grey-900);\n\t\t\tfont-size: var(--font-size-1);\n\t\t\tfont-weight: var(--font-weight-paragraph);\n\t\t\tline-height: var(--font-line-height-1);\n\t\t}\n\t");
};
var GlobalTheme = (0, _styledComponents.createGlobalStyle)(["", ""], function (_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'very' : _ref$brand,
    _ref$renderGlobalRese = _ref.renderGlobalResetStyles,
    renderGlobalResetStyles = _ref$renderGlobalRese === void 0 ? true : _ref$renderGlobalRese;
  var globalStyles = renderGlobalResetStyles ? "html{box-sizing:border-box;}*,:after,:before{box-sizing:inherit}:focus{outline:1px dotted #3a64cb}body,caption,fieldset,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0}ol,ul{list-style:none}img{max-width:100%;height:auto}fieldset,iframe{border:0}button,button:active{color:unset}\n\t\t\t.hidden,#speedtrap {display: none}" : '';
  var fuseBodyStyles = renderGlobalResetStyles ? "html{font-size: var(--font-base-size)}\n\t\t\t\tbody {color: ".concat(_themesConfig.themesConfig[brand].baseFontColour, ";font-display: swap;font-family: var(--font-brand), Arial, Helvetica, sans-serif;} input, textarea, select, button {font-family: inherit;}") : '';
  return "\n            /* This is the legacy reset - needs a 2022 update */\n            ".concat(globalStyles, "\n\n            :root {\n\t\t\t\t").concat(createBrandFontFamilyCss(brand), "\n\t\t\t\t").concat(baseFontSizeCss, "\n\t\t\t\t").concat(generateTypographyCustomProperties(brand), "\n\t\t\t\t/* Old spacing tokens below to be removed upon decommissioning */\n\t\t\t\t").concat(createOldSpacingCustomProperties(), "\n\t\t\t\t").concat(createNewSpacingCustomProperties(), "\n\t\t\t\t").concat(createPageSpacingCustomProperties(), "\n\t\t\t\t").concat(createBrandColoursCustomProperties(brand), "\n\t\t\t\t").concat(createColoursCustomProperties(), "\n\t\t\t\t").concat(createElevationCustomProperties(), "\n\t\t\t\t").concat(createBorderCustomProperties(), "\n            }\n\n\t\t\t@font-face {\n\t\t\t\tfont-family: 'Very Sans';\n\t\t\t\tsrc: url('/sa/fe-global-assets/fonts/VerySans-Medium.woff');\n\t\t\t\tfont-weight: ").concat((0, _typography.paragraph)(brand).fontWeight, "; // referenced as 500 in Figma\n\t\t\t\tfont-display: swap;\n\t\t\t}\n\t\t\t@font-face {\n\t\t\t\tfont-family: 'Very Sans';\n\t\t\t\tsrc: url('/sa/fe-global-assets/fonts/VerySans-Bold.woff');\n\t\t\t\tfont-weight: ").concat((0, _typography.heading)(brand).fontWeight, ";\n\t\t\t\tfont-display: swap;\n\t\t\t}\n\t\t\t@font-face {\n\t\t\t\tfont-family: 'Very Sans';\n\t\t\t\tsrc: url('/sa/fe-global-assets/fonts/VerySans-Headline.woff');\n\t\t\t\tfont-weight: ").concat((0, _typography.display)(brand).fontWeight, "; // referenced as 400 in Figma\n\t\t\t\tfont-display: swap;\n\t\t\t}\n\n            ").concat(fuseBodyStyles, "\n\t\t\t").concat(createmarkdownStyles(brand), "\n\t\t");
});
function GlobalThemeComponent(_ref2) {
  var brand = _ref2.brand,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(GlobalTheme, _extends({
    brand: validBrands.includes(brand) ? brand : 'very'
  }, props));
}
GlobalThemeComponent.propTypes = propTypes;
GlobalThemeComponent.defaultProps = defaultProps;
var _default = exports["default"] = GlobalThemeComponent;